module.exports = __webpack_public_path__ + "04_bob_black.34f8d125.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/04_bob_black.png
// module id = uhGa
// module chunks = 0